import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const LegalLayout = ({ title, updated, children, testid }) => (
  <article className="bg-[#FDFCF0]" data-testid={testid}>
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
        <nav className="flex items-center gap-1 text-sm text-slate-500 mb-4" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-[#0033A0]">Home</Link>
          <ChevronRight size={14} />
          <span className="text-slate-700">{title}</span>
        </nav>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-[#1A1A1A]">{title}</h1>
        <p className="mt-3 text-sm text-slate-500">Last updated: {updated}</p>
      </div>
    </div>
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
      <div className="legal-body space-y-6 text-slate-700 leading-relaxed">{children}</div>
    </div>
  </article>
);

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="text-xl md:text-2xl font-semibold text-[#1A1A1A] mb-3">{heading}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export default LegalLayout;
